import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const shipShipmentRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/shipments/:id/ship',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/shipments/:id/ship' \\
--header 'Authorization: Bearer <TOKEN>' \\
--header 'Content-Type: application/json'
`,
};

const shipShipmentResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 9,
        'number': 'S10014',
        'order': {
            'id': 11,
            'number': '10014',
            'type': 'SO'
        },
        'carrier': {
            'id': 4,
            'name': 'Fedex',
            'service': {
                'id': 10,
                'name': 'Standard Overnight'
            }
        },
        'fobPointName': 'Origin',
        'locationGroup': {
            'id': 5,
            'name': 'SLC'
        },
        'lastModified': {
            'dateLastModified': '2026-03-02T14:59:32.537+00:00'
        },
        'dateCreated': '2026-01-09T23:31:28.742+00:00',
        'note': '',
        'contact': 'Captain Kirk',
        'email': 'elcapitan@example.com',
        'phone': '801-932-1101',
        'billOfLading': '00000000000000093',
        'shipToAddress': {
            'name': 'Captain Kirk',
            'street': '17 Enterprise Way',
            'city': 'Tanner',
            'state': 'ND',
            'postalCode': '25897',
            'country': 'UNITED STATES'
        },
        'status': 'Shipped',
        'cartons': [
            {
                'id': 9,
                'cartonNumber': 1,
                'trackingNumber': '',
                'freightWeight': '0',
                'freightWeightUom': {
                    'id': 3,
                    'name': 'Pound',
                    'abbreviation': 'lbs'
                },
                'freightAmount': '0',
                'sscc': '100000000000000090',
                'dateCreated': '2026-01-09T23:31:28.742+00:00',
                'width': '0',
                'height': '0',
                'length': '0',
                'sizeUom': {
                    'id': 7,
                    'name': 'Inch',
                    'abbreviation': 'in'
                },
                'insuredValue': '0',
                'shipperRelease': false,
                'additionalHandling': false,
                'shipItems': [
                    {
                        'id': 10,
                        'orderItemId': 17,
                        'product': {
                            'id': 27,
                            'name': 'FG2100',
                            'description': 'Extreme Mountain Bike'
                        },
                        'tagNumber': '369',
                        'quantity': '1',
                        'uom': {
                            'id': 1,
                            'name': 'Each',
                            'abbreviation': 'ea'
                        },
                        'totalCost': '0'
                    }
                ]
            }
        ],
        'customFields': [
            {
                'id': 21,
                'name': 'Custom',
                'value': 'Sample text value',
                'type': 'Text'
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'ship-shipment',
    title: 'Ship a shipment',
    description: 'Ships a shipment, completing the fulfillment process. Consuming inventory and fulfilling the associated order. Shipments in either "Entered" or "Packed" status can be shipped — "Entered" shipments are automatically packed before shipping. Returns a 400 error if the shipment has already been shipped.',
    endpoint: {
        verb: 'POST',
        path: '/shipments/:id/ship',
        tooltip: 'Ship a shipment',
    },
    attributes: [],
    requestObject: shipShipmentRequest,
    responseObject: shipShipmentResponse,
};

export default data;